import SolutionList from "./SolutionList.container";

export default SolutionList;
